import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useRewardStore = defineStore('reward', () => {
  // State
  const otherRewardList = ref([])
  const pointsRewardList = ref([])
  const rewardList = ref([])
  const activityNo = ref(null)
  const receiveNo = ref(null)
  const withdrawRule = ref({})
  const rewardType = ref(null)
  const isPlaying = ref(false)
  const callback = ref(null)
  const orderColumn = ref('createTime')
  const lang = ref('en-US')
  const receiving = ref(false)
  const pending = ref(false)

  // Getters
  const getPending = computed(() => pending.value)

  // Actions
  function setOtherRewardList(data) {
    otherRewardList.value = data
  }

  function setPointsRewardList(data) {
    pointsRewardList.value = data
  }

  function setRewardList(data) {
    rewardList.value = data
  }

  function setActivityNo(data) {
    activityNo.value = data
  }

  function setReceiveNo(data) {
    receiveNo.value = data
  }

  function setWithdrawRule(data) {
    withdrawRule.value = data
  }

  function setRewardType(data) {
    rewardType.value = data
  }

  function setIsPlaying(data) {
    isPlaying.value = data
  }

  function setCallback(data) {
    callback.value = data
  }

  function setOrderColumn(data) {
    orderColumn.value = data
  }

  function setLang(data) {
    lang.value = data
  }

  function setReceiving(data) {
    receiving.value = data
  }

  function setPending(data) {
    pending.value = data
  }

  function resetPendingState() {
    pending.value = false
    withdrawRule.value = {}
    activityNo.value = null
    receiveNo.value = null
  }

  return {
    // State
    otherRewardList,
    pointsRewardList,
    rewardList,
    activityNo,
    receiveNo,
    withdrawRule,
    rewardType,
    isPlaying,
    callback,
    orderColumn,
    lang,
    receiving,
    pending,

    // Getters
    getPending,

    // Actions
    setOtherRewardList,
    setPointsRewardList,
    setRewardList,
    setActivityNo,
    setReceiveNo,
    setWithdrawRule,
    setRewardType,
    setIsPlaying,
    setCallback,
    setOrderColumn,
    setLang,
    setReceiving,
    setPending,
    resetPendingState,
  }
})
